import { IDecision } from '../helpers';

export const DEFAULT_DECISION: IDecision = {
    ComponentId: '',
    Branches: [],
    Properties: []
};

export const CONDITION_LEFT_KEY: string = 'condition_left';
export const CONDITION_RIGHT_KEY: string = 'condition_right';


// WEBPACK FOOTER //
// ./source/ts/constants/decisions.ts